import type { Data, Event } from '@ori-events/open-product-info-dialog';
import { DialogMode, Name } from '@ori-events/open-product-info-dialog';
import { isNonNullable } from '@ori/ts-utils';
import { useEffect, useMemo, useState } from 'react';

export interface UseOpenEventProps {
  onOpen: () => void;
}

export const useOpenEvent = ({ onOpen }: UseOpenEventProps) => {
  const [atpClusterId, setAtpClusterId] = useState<Data['atpClusterId']>();
  const [initialProductCode, setInitialProductCode] = useState<Data['initialProductCode']>();
  const [lineNumber, setLineNumber] = useState<Data['lineNumber']>();
  const [mode, setMode] = useState<Data['mode']>(DialogMode.StandardBuy);
  const [originalItemCode, setOriginalItemCode] = useState<Data['originalItemCode']>();
  const [originalQuantity, setOriginalQuantity] = useState<Data['originalQuantity']>();
  const [placement, setPlacement] = useState<Data['placement']>();
  const [position, setPosition] = useState<Data['position']>();
  const [productCodes, setProductCodes] = useState<Data['productCodes']>([]);
  const [droppingId, setDroppingId] = useState<number>();
  const [subscriptionId, setSubscriptionId] = useState<number>();
  useEffect(() => {
    const onOpenProductInfoDialog = ({ detail }: Event) => {
      setAtpClusterId(detail.atpClusterId);
      setDroppingId(detail.replaceSubscription?.droppingId);
      setInitialProductCode(detail.initialProductCode);
      setLineNumber(detail.lineNumber);
      setMode(detail.mode);
      setOriginalItemCode(detail.originalItemCode);
      setOriginalQuantity(detail.originalQuantity);
      setPlacement(detail.placement);
      setPosition(detail.position);
      setProductCodes(detail.productCodes);
      setSubscriptionId(detail.replaceSubscription?.subscriptionId);
      onOpen();
    };
    window.addEventListener(Name, onOpenProductInfoDialog);

    return () => window.removeEventListener(Name, onOpenProductInfoDialog);
  }, [onOpen]);

  return useMemo(
    () => ({
      atpClusterId,
      initialProductCode,
      lineNumber,
      mode,
      originalItemCode,
      originalQuantity,
      placement,
      position,
      productCodes,
      replaceSubscription:
        isNonNullable(droppingId) && isNonNullable(subscriptionId) ? { droppingId, subscriptionId } : undefined,
    }),
    [
      atpClusterId,
      droppingId,
      initialProductCode,
      lineNumber,
      mode,
      originalItemCode,
      originalQuantity,
      placement,
      position,
      productCodes,
      subscriptionId,
    ],
  );
};
